import React from 'react';
import CountUp from 'react-countup';
import About1 from '../../images/for-pharm-about.webp';
import About3 from '../../images/signeture.png';


const About2 = (props) => {


    return (
        <section className="about_section_s2">
            <div className="container">
                <div className="wrapper">
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-12">
                            <div className="about_left">
                                <img src={About1} alt="" />
                                <div className="award">
                                    <div className="icon">
                                        <i className="flaticon-cup"></i>
                                    </div>
                                    <div className="text">
                                        <h2><CountUp end={25} enableScrollSpy />+</h2>
                                        <p>Years Of Experience</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-12">
                            <div className="content">
                                <h2>Partner with Pharmacy Freedom Fund</h2>
                                <h3>Elevate Your Pharmacy's Potential</h3>
                                <p>At Pharmacy Freedom Fund, we understand the challenges facing independent pharmacies in today's competitive landscape. Our partnership approach is designed to preserve your legacy while unlocking your pharmacy's full potential. We bring capital, expertise, and a proven track record of optimizing operations and driving growth</p>
                                <p>By joining forces with us, you gain access to cutting-edge technology, enhanced buying power, and operational efficiencies that can significantly boost your pharmacy's value and profitability. Our team works closely with you to implement tailored strategies that respect your unique community role while positioning your business for long-term success</p>
                                <div className="ceo">
                                    <div>
                                        <h4>Amr Hillal</h4>
                                        <span>General Partner</span>
                                    </div>
                                    <div>
                                        <div
                                            style={{
                                                fontFamily: "'Great Vibes', cursive",
                                                fontSize: "48px",
                                                color: "#2c3e50",
                                                textAlign: "center",
                                                padding: "10px",
                                            }}
                                        >
                                            Amr Hillal
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default About2;